import { render, staticRenderFns } from "./WorkIconMobilePhone.vue?vue&type=template&id=3c567892"
import script from "./WorkIconMobilePhone.vue?vue&type=script&lang=js"
export * from "./WorkIconMobilePhone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports